// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"757ed492","732":"1ad22aea","977":"b40ce421"}[chunkId] + ".chunk.js";
};